document.addEventListener("DOMContentLoaded", function () {
	const swipersMap = new Map();

	function isMobileDevice() {
		return window.matchMedia("(max-width: 767px)").matches;
	}

	function isGrid1or2Active(number) {
		switch (number) {
			case 1:
				return !!document.querySelector('button[data-layout-mode="grid-1"].btn--active');
			case 2:
				return !!document.querySelector('button[data-layout-mode="grid-2"].btn--active');
			default:
				return false;
		}
	}

	/**
	 * Show the right display type based on button selection (slider vs fixed image)
	 */
	function updateAllCardsType() {
		const isMobile = isMobileDevice();
		const isMobileAndGrid1Or2Active = (isMobile && isGrid1or2Active(1)) || (isMobile && isGrid1or2Active(2));
		document.querySelectorAll('[data-infinite-mobile-scroll="true"]').forEach(function (card) {
			if (isMobileAndGrid1Or2Active) {
				activateSliderOnCard(card);
			} else {
				disableSliderOnCard(card);
			}
		});
	}

	// Enable infinite scroll for visible cards only
	function activateSliderOnCard(card) {
		if (card.dataset.cardType === "slider") {
			return;
		}
		const wrapper = card.querySelector(".product-card__image-scroll-toggle");
		if (!wrapper) {
			return;
		}

		const scrollMobile = wrapper.querySelector(".product-card__image-scroll-mobile");
		const normalWrapper = wrapper.querySelector(".product-card__image-wrapper");
		if (!scrollMobile || !normalWrapper) {
			return;
		}

		scrollMobile.style.display = "";
		normalWrapper.style.display = "none";
		enableInfiniteScrollSwiper(card);
		card.dataset.cardType = "slider";
	}

	function disableSliderOnCard(card) {
		if (card.dataset.cardType === "fixed") {
			return;
		}

		const wrapper = card.querySelector(".product-card__image-scroll-toggle");
		if (!wrapper) {
			return;
		}

		const scrollMobile = wrapper.querySelector(".product-card__image-scroll-mobile");
		const normalWrapper = wrapper.querySelector(".product-card__image-wrapper");
		if (!scrollMobile || !normalWrapper) {
			return;
		}

		scrollMobile.style.display = "none";
		normalWrapper.style.display = "";
		disableInfiniteScroll(card);
		card.dataset.cardType = "fixed";
	}

	function enableInfiniteScrollSwiper(card) {
		const container = card.querySelector(".swiper");
		const marker = card.querySelector("[data-image-marker]");
		const slideCount = container.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
		marker.style.setProperty("--total-slide-count", slideCount);
		const swiper = new FoxTheme.Swiper.Swiper(container, {
			cssMode: true,
			slidesPerView: 1,
			on: {
				slideChange: function (swiper) {
					marker.style.setProperty("--active-slide-index", swiper.realIndex);
				},
			},
		});
		swipersMap.set(card, swiper);
	}

	function disableInfiniteScroll(card) {
		const registeredSwiper = swipersMap.get(card);
		registeredSwiper?.destroy();
		swipersMap.delete(card);
	}

	//

	window.addEventListener("resize", updateAllCardsType, { passive: true });

	var switcher = document.querySelector("layout-switcher");
	if (!switcher) return;
	switcher.addEventListener("click", function (e) {
		var btn = e.target.closest("button.btn--icon");
		if (!btn) return;
		switcher.querySelectorAll("button.btn--icon").forEach(function (b) {
			b.classList.remove("btn--active");
		});
		btn.classList.add("btn--active");
	});

	document.addEventListener("product-card-added", (e) => {
		updateAllCardsType();
	});

	updateAllCardsType();
});
